module.exports = __webpack_public_path__ + "static/media/sc6.10.c1e69f4b.mp4";